module.exports = __webpack_public_path__ + "img/twitter.095df65.21b808ec.png";